import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SurveyPerformanceBuyer,
  SurveyPerformanceFilters,
  SurveyPerformanceResult,
} from '../models/survey-performance-report.model';
import { SurveyPerformanceReportApi } from '../api/survey-performance-report.api';

@Injectable({ providedIn: 'root' })
export class SurveyPerformanceReportService {
  private readonly _api = inject(SurveyPerformanceReportApi);

  public buyers(): Observable<SurveyPerformanceBuyer[]> {
    return this._api.buyers();
  }

  public results(
    filters: SurveyPerformanceFilters,
  ): Observable<SurveyPerformanceResult[]> {
    return this._api.results(filters);
  }
}
